export default {"src":"/_next/static/media/sticker-4.94e2906a.svg","height":192,"width":192,"blurWidth":0,"blurHeight":0};